/**
 * URL utility for centralized form submission URL handling
 */

/**
 * Build a complete form submission URL
 * @param {string} controller - The controller name
 * @param {string|number} funnelPageId - The funnel page ID
 * @param {Object} options - Additional options
 * @returns {string} - The complete submission URL
 */
export const buildFormSubmissionUrl = (controller, funnelPageId, options = {}) => {
    const { useAbsoluteUrl = true } = options;
    
    // Default controller fallback
    const controllerName = controller || 'HookEvents';
    
    // Build the path portion
    const urlPath = `/${controllerName}/ajax-check-form/${funnelPageId}`;
    
    // Return absolute or relative URL as requested
    return useAbsoluteUrl ? `${window.location.origin}${urlPath}` : urlPath;
};

/**
 * Extract controller name from URL
 * @param {string} url - The URL to extract from
 * @returns {string|null} - The extracted controller name or null
 */
export const extractControllerFromUrl = (url) => {
    if (!url) return null;
    
    try {
        // Handle both absolute and relative URLs
        const urlParts = url.startsWith('/') 
            ? url.split('/').filter(Boolean) 
            : new URL(url).pathname.split('/').filter(Boolean);
        
        return urlParts.length > 0 ? urlParts[0] : null;
    } catch (error) {
        console.error('Error extracting controller from URL:', error);
        return null;
    }
};

/**
 * Extract funnel page ID from URL
 * @param {string} url - The URL to extract from
 * @returns {string|null} - The extracted funnel page ID or null
 */
export const extractFunnelPageIdFromUrl = (url) => {
    if (!url) return null;
    
    try {
        // Handle both absolute and relative URLs
        const urlParts = url.startsWith('/') 
            ? url.split('/').filter(Boolean) 
            : new URL(url).pathname.split('/').filter(Boolean);
        
        return urlParts.length > 0 ? urlParts[urlParts.length - 1] : null;
    } catch (error) {
        console.error('Error extracting funnel page ID from URL:', error);
        return null;
    }
};

export default {
    buildFormSubmissionUrl,
    extractControllerFromUrl,
    extractFunnelPageIdFromUrl
}; 